import { Injectable, NgZone } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { ErrorMessage } from './error-handler.service';
import { SnackbarComponent } from '../shared/snackbar/snackbar.component';
import Swal from 'sweetalert2';
@Injectable({
  providedIn: 'root',
})
export class NotifierService {
  
  confirmBtnClr: string = '#3085d6';
  cancelBtnClr: string = '#DC3545';
  private successAutoHideSec = 10;
  private errorAutoHideSec = 30;
  private horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  private verticalPosition: MatSnackBarVerticalPosition = 'top'
  private snackBarConfig: MatSnackBarConfig;

  constructor(
      private snackBar: MatSnackBar, 
      private zone: NgZone
    ) {}


  public successMessageHandler(message: string) {
    this.openSnackBar(message, 'success');
  }
  public failedMessageHandler(message: string){
    this.openSnackBar(message,'error');
  }

  public openSnackBar(message, value) {
    this.snackBarConfig = new MatSnackBarConfig();
    this.snackBarConfig.horizontalPosition = this.horizontalPosition;
    this.snackBarConfig.verticalPosition = this.verticalPosition;
    this.snackBarConfig.data = {
      message,
      type: value,
    };

    if (value === 'success') {
      this.snackBarConfig.panelClass = 'success-snackbar';
      this.snackBarConfig.duration = this.successAutoHideSec * 1000;
    } else if(value === 'partial-success') {
      this.snackBarConfig.panelClass = 'partial-success-snackbar';
      this.snackBarConfig.duration = this.errorAutoHideSec * 1000;
    } else {
      this.snackBarConfig.panelClass = 'error-snackbar';
      this.snackBarConfig.duration = this.errorAutoHideSec * 1000;
    }

    const snackbarRef = this.snackBar.openFromComponent(SnackbarComponent, {
      ...this.snackBarConfig,
    });
    snackbarRef.instance.message = message;
  }

  public showServerError(error: ErrorMessage) {
    this.zone.run(() => {
      this.snackBarConfig = new MatSnackBarConfig();
      this.snackBarConfig.horizontalPosition = this.horizontalPosition;
      this.snackBarConfig.verticalPosition = this.verticalPosition;
      this.snackBarConfig.data = {
        serverError: error,
        isServerError: true,
      };
      this.snackBarConfig.panelClass = 'error-snackbar';
      this.snackBarConfig.duration = this.errorAutoHideSec * 1000;

      this.snackBar.openFromComponent(SnackbarComponent, {
        ...this.snackBarConfig,
      });
    });
  }
  public async asyncShowWarningMessage(
    title: string,
    message: string,
    confirmButtonText: string,
    cancelButtonText: string
  ) {
    return await Swal.fire({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: true,
      title: title,
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: confirmButtonText,
      cancelButtonText: cancelButtonText,
      confirmButtonColor: this.confirmBtnClr,
      cancelButtonColor: this.cancelBtnClr,
      allowEscapeKey: true,
      allowOutsideClick: true
    });
  }
}
